const dotenv = {
  SERVER: process.env.REACT_APP_SERVER_URL,
};

export default dotenv;
